import resolver, {ResolverSettings} from './utils/resolver';
import {
  CreateOrUpdateBulkLockPayload,
  Paginated,
  ThirdPartyDealPayload,
} from '../utils/types';
import {ListDeal} from '../utils/upselling';

class UpsellingApi {
  ENDPOINTS = {
    deals: (params = '') => `upselling/deals/?${params}`,
    oneDeal: (id: string) => `upselling/third-party-deals/${id}/`,
    thirdPartyDeal: (id?: string) => `upselling/third-party-deals/${id}`,
    bulkLock: (id?: string) => `upselling/third-party-deals/bulk-lock/${id}`,
  };

  getDeals(params = '', resolverSettings?: ResolverSettings) {
    return resolver<Paginated<ListDeal>>(
      this.ENDPOINTS.deals(params),
      null,
      resolverSettings,
    );
  }

  createDeal(payload: unknown, params = '', resolverSettings?: ResolverSettings) {
    return resolver(
      this.ENDPOINTS.deals(params),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
  }

  deleteDeal<T>(id: string, resolverSettings?: ResolverSettings) {
    return resolver<T>(
      this.ENDPOINTS.oneDeal(id),
      {
        method: 'DELETE',
      },
      resolverSettings,
    );
  }

  createOrUpdateThirdPartyDeal(
    payload: ThirdPartyDealPayload,
    resolverSettings?: ResolverSettings,
  ) {
    const method = payload?.deal_id ? 'PATCH' : 'POST';
    return resolver(
      this.ENDPOINTS.thirdPartyDeal(payload?.deal_id ?? ''),
      {
        method,
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
  }

  createOrUpdateBuldLock(
    payload: CreateOrUpdateBulkLockPayload,
    resolverSettings?: ResolverSettings,
  ) {
    const method = payload?.bulk_lock_id ? 'PATCH' : 'POST';
    return resolver(
      this.ENDPOINTS.bulkLock(payload?.bulk_lock_id ?? ''),
      {
        method,
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
  }
}

export {UpsellingApi};
